import { Outlet } from 'react-router';

import { RequireAuth } from '@sorare/core/src/routing/RequireAuth';

const NoCardRouteLayout = () => {
  return (
    <RequireAuth>
      <Outlet />
    </RequireAuth>
  );
};
export default NoCardRouteLayout;
